import React from 'react';
import { formatCurrency } from '../../utils/formatters';
import { FiAlertCircle } from 'react-icons/fi';
import './IncomeCheck.css';

const IncomeCheck = ({ task }) => {
  // Mock Data
  const data = [
    { source: 'Declared', gross: 35000, net: 26000, period: 'Monthly', confidence: '—' },
    { source: 'Bank Statement', gross: null, net: 25500, period: '3-month avg', confidence: 'High' },
    { source: 'Employment Letter', gross: 35000, net: null, period: 'Annual/12', confidence: 'High' }
  ];

  const variance = ((data[0].net - data[1].net) / data[0].net) * 100;
  const showWarning = Math.abs(variance) > 15;

  return (
    <div className="income-check card">
      <div className="card-header">
        <h2>Income Verification</h2>
      </div>
      <div className="card-body">
        {showWarning && (
          <div className="variance-warning">
            <FiAlertCircle className="icon" />
            <span>Warning: Declared net income varies by &gt;15% from verified bank statement average.</span>
          </div>
        )}

        <div className="table-responsive">
          <table className="comparison-table">
            <thead>
              <tr>
                <th>Source</th>
                <th>Gross Income</th>
                <th>Net Income</th>
                <th>Period</th>
                <th>Confidence</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => (
                <tr key={idx} className={row.source === 'Declared' ? 'row-declared' : ''}>
                  <td><strong>{row.source}</strong></td>
                  <td>{row.gross ? formatCurrency(row.gross) : '—'}</td>
                  <td>{row.net ? formatCurrency(row.net) : '—'}</td>
                  <td>{row.period}</td>
                  <td>
                    {row.confidence !== '—' ? (
                      <span className={`confidence-badge ${row.confidence.toLowerCase()}`}>
                        {row.confidence}
                      </span>
                    ) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="income-notes">
          <h3>Verification Notes</h3>
          <p className="helper-text">
            Bank statement extraction was automated. The average includes regular salary deposits identified by employer name.
          </p>
        </div>
      </div>
    </div>
  );
};

export default IncomeCheck;
